import React from 'react'
import AboutHero from '../components/AboutHero/AboutHero'
import VisionSection from '../components/VisionSection/VisionSection'
import ExpertiseSection from '../components/ExpertiseSection/ExpertiseSection'
import PhilosophySection from '../components/PhilosophySection/PhilosophySection'
import Footer from '../components/Footer/Footer'
import VisitEliteOptix from '../components/VisitEliteOptix/VisitEliteOptix'
import { Helmet } from 'react-helmet'

const About = () => {
  return (
    <>
    <Helmet>
        <title>About Elite Optix | Expert Eye Care & Designer Eyewear</title>
        <meta
          name="description"
          content="Learn about Elite Optix's commitment to exceptional eye care and luxury eyewear. Discover our story, philosophy, and expertise in vision health."
        ></meta>
        <link
          rel="canonical"
          href="https://eliteoptix.com/about"
        />
    </Helmet>
      <AboutHero page="about" img={"/aboutus-hero.png"} title="Your Vision, Our Commitment" subtitle="At Elite Optix, expert eye care meets luxury eyewear. Every visit is designed to bring clarity, comfort, and style to your life." />
      <VisionSection page="about"
        title="Our Story"
        subtext="Elite Optix began with a simple idea: eye care should be precise, personal, and stylish. From advanced eye exams to curated designer frames, every visit is crafted to bring clarity, confidence, and a touch of luxury to your everyday life. See better, feel better, and express your style through eyewear that speaks for you."
        listordesc={["From comprehensive eye exams to personalized lens fitting, we bring craftsmanship, care, and cutting edge technology to every detail."]} />
      <div className="bg_gradient" >
        <PhilosophySection />
        <ExpertiseSection />
        <VisitEliteOptix />
      </div>
      <Footer />
    </>
  )
}

export default About